export const PATHS = {
  login: {
    pathBase: '/login/',
  },
  dashboard: {
    pathBase: '/dashboard/',
  },
  ticket: {
    pathBase: '/generar-ticket/',
    generateVirtualTicket: 'virtual',
    generatePresentialTicket: 'presencial',
  },
  monitor: {
    pathBase: '/monitor-de-espera/',
    assignmentMonitor: 'asignacion',
    attentionMonitor: 'atencion',
  },
  box: {
    pathBase: '/box/',
    assignmentBox: 'asignacion',
    attentionBox: 'atencion',
  },
  errors: {
    deny: '/403',
    notFound: '/404',
    serverError: '/500',
  },
};
